module.exports = __webpack_public_path__ + "images/wrestling1-0a04d9cd5d52cab9d9bfdca0101ac260.jpg";